<template>
  <v-chip
    v-bind="$attrs"
    class="info-chip py-2 px-1 d-flex align-center justify-center"
  >
    <slot name="default" />
    <div class="chip-icon" :style="`height: ${iconSize}px`">
      <slot name="icon" />
    </div>
    <div class="chip-text mx-2">
      <slot name="text" />
    </div>
  </v-chip>
</template>

<script>
export default {
  name: "StoryCityInfoChip",
  props: {
    iconSize: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style lang="scss" scoped>
.v-chip.info-chip {
  border-radius: 8px;
  height: auto;
}

.info-chip .chip-text {
  color: var(--v-textOnAccent-base);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
